module.exports = __webpack_public_path__ + "img/PX.ed1e6c1d.jpg";